<template>
  <div class="flex items-center space-x-2 whitespace-nowrap">
    <span v-if="iconProp" class="translate-y-0-25 transform">
      <icon-base v-bind="iconProp" />
    </span>
    <span>{{ $t("ORCHESTRATION.MASTER") }}: {{ statusDescription }}</span>
    <span v-if="shouldShowDropdownIcon" class="-translate-y-0-5 transform">
      <icon-base height="6" width="10" :icon="IconDropdownArrow" />
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { DATA_ORCHESTRATION_MASTER_STATUS_NOT_STARTED } from "@/helpers/constants";
import { DATA_ORCHESTRATION_MASTER_STATUS_OPTIONS } from "@/helpers/constants/dataOrchestrationMasterStatusOptions";

import IconDropdownArrow from "@/components/icons/IconDropdownArrow.vue";

import type {
  DataOrchestrationMasterStatus,
  DataOrchestrationMasterStatusType,
} from "@/models/orchestration";
import type { IRootState } from "@/models/state";
import type { PropType } from "vue";

const { getters } = useStore<IRootState>();

const props = defineProps({
  status: {
    type: Number as PropType<DataOrchestrationMasterStatusType>,
    default: 1,
  },
  shouldShowDropdownIcon: {
    type: Boolean,
    default: true,
  },
});

const dataOrchestrationMasterStatuses = computed<
  Record<DataOrchestrationMasterStatusType, DataOrchestrationMasterStatus>
>(() => getters["options/dataOrchestrationMasterStatuses"]);

const statusDescription = computed(
  () =>
    dataOrchestrationMasterStatuses.value[props.status] ||
    DATA_ORCHESTRATION_MASTER_STATUS_NOT_STARTED
);

const iconProp = computed(() => {
  const option =
    DATA_ORCHESTRATION_MASTER_STATUS_OPTIONS[statusDescription.value];
  return option.icon ? option : null;
});
</script>
